import {
  loadStartupModule,
  markStartupModulesLoaded,
  recoverStartupModuleFailure,
} from './platform/lib/startupModuleLoading';
import { startPerformanceRum } from './platform/performance';
import { publicRecordingRoute, publicSharedLinkToken } from './app/video/lib/recordingRoute';
import { capturePendingRudiThread } from './platform/lib/pendingRudiThread';
import { preloadInitialLanguageCatalogs } from './i18n/languages';
import { storedSessionOpensApp } from './platform/lib/bootPrefetch';
import { loadAppLayoutModule } from './platform/components/appShellModules';
import { installOverlayScrollbars } from './platform/lib/overlayScrollbars';
import { installWorkspaceSelection } from './platform/lib/workspaceSelection';

// Before any request: which organisation this tab works in (ADR 0113).
installWorkspaceSelection();
startPerformanceRum();
// globals.css hides the browser's scrollbars; these overlay bars replace them.
installOverlayScrollbars();
capturePendingRudiThread();
// A German first screen needs its catalogs; fetch them beside the startup code.
preloadInitialLanguageCatalogs();

const recordingRoute = publicRecordingRoute(window.location.pathname);
const sharedLinkToken = publicSharedLinkToken(window.location.pathname);
const errorHandlers = loadStartupModule(() => import('./platform/lib/installStartupErrorHandlers'));

// A signed-in reload of the application needs the shell, which the startup
// code leaves out for the login form; load it beside the startup code.
if (!recordingRoute && !sharedLinkToken && storedSessionOpensApp(window.location.pathname)) {
  void loadStartupModule(loadAppLayoutModule).catch(error =>
    console.warn('[Rudi] Shell preload failed:', error)
  );
}

if (!recordingRoute && !sharedLinkToken) {
  void loadStartupModule(() => import('./platform/components/TabBar/initialViewPreload'))
    .then(({ preloadInitialView }) => {
      preloadInitialView(window.location.pathname);
    })
    .catch(error => console.warn('[Rudi] Initial view preload failed:', error));
}

void errorHandlers
  .then(async () => {
    if (recordingRoute) {
      const { mountRecordingPage } = await loadStartupModule(
        () => import('./app/video/recordingRoot')
      );
      await mountRecordingPage(recordingRoute);
    } else if (sharedLinkToken) {
      const { mountSharedLinkPage } = await loadStartupModule(
        () => import('./app/video/sharedLinkRoot')
      );
      await mountSharedLinkPage(sharedLinkToken);
    } else {
      await loadStartupModule(() => import('./applicationRoot'));
    }
  })
  .then(() => markStartupModulesLoaded())
  .catch(async error => {
    const normalized = error instanceof Error ? error : new Error(String(error));
    if (recoverStartupModuleFailure(normalized)) return;
    try {
      const { showFallbackError } = await errorHandlers;
      showFallbackError(normalized);
    } catch {
      // The error-handler chunk itself failed to load, so render a bare fallback.
      console.error('[Rudi] Fatal initialization error:', normalized);
      const rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.setAttribute('aria-busy', 'false');
        rootElement.innerHTML = `
          <main data-rudi-startup-fallback style="min-height:100vh;display:grid;place-items:center;padding:20px;font-family:sans-serif;text-align:center">
            <div>
              <h1>Failed to Load Application</h1>
              <p>The application files could not be loaded. Reload the application to try again.</p>
              <button type="button" style="border-radius:1.5rem" onclick="window.location.reload()">
                Reload Application
              </button>
            </div>
          </main>
        `;
      }
    }
  });
